import { fetchApi } from 'api/index'

export const changeUserDefaultPhotoModeApi = (mode: string) =>
  fetchApi('/settings/main_photo_mode/switchMode', {
    method: 'POST',
    body: JSON.stringify({ mode }),
  })
